import { colorMix } from "../../theme/AppTheme";

export function getButtonColors(color, variant, { text, bg }) {
    const theme = {
        primary: { text: "var(--header-text)", bg: "var(--primary)" },
        secondary: { text: "var(--text)", bg: "var(--secondary)" },
        error: { text: "white", bg: "var(--error)" },
        success: { text: "white", bg: "var(--success)" },
        warning: { text: "white", bg: "var(--warning)" },
        info: { text: "white", bg: "var(--info)" },
    }[color] ?? { text: "var(--text)", bg: "var(--bg)" };

    /* Remember whether the caller named a text colour, so the variants below
       can pick a sensible default without discarding an explicit override. */
    const explicitText = text;

    text ??= theme.text;
    bg ??= theme.bg;

    return (
        {
            contained: { bg, text, border: bg, shadow: colorMix(bg, 20) },

            outlined: {
                bg: "transparent",
                /* `theme.text` is the colour for text sitting ON the brand
                   fill — white, for primary. On this variant's transparent
                   ground that renders white-on-white and the label vanishes,
                   so the brand colour itself is the readable choice. */
                text: explicitText ?? bg,
                border: bg,
                shadow: colorMix(bg, 20),
            },

            soft: {
                bg: colorMix(bg, 20),
                text: bg,
                border: colorMix(bg, 20),
                shadow: colorMix(bg, 20),
            },

            /* Same transparent-ground reasoning as `outlined` above. */
            "soft-outlined": {
                bg: "transparent",
                text: explicitText ?? bg,
                border: colorMix(bg, 20),
                shadow: colorMix(bg, 20),
            },

            text: {
                bg: "transparent",
                border: "transparent",
                ...(!color || color === "default"
                    ? {
                          text,
                          shadow: colorMix(text, 20),
                      }
                    : { text: bg, shadow: colorMix(bg, 20) }),
            },
        }[variant] ?? { bg, text, border: bg, shadow: colorMix(bg, 20) }
    );
}
